import type {ValueOf} from '@myparcel-frontend/types';

export type Tier = ValueOf<typeof TierName>;

export const TierName = {
  Light: 'light',
  Start: 'start',
  Plus: 'plus',
  Premium: 'premium',
  Max: 'max',
} as const;

export const TierId = {
  Light: 0,
  Start: 1,
  Plus: 2,
  Premium: 3,
  Max: 4,
} as const;

export const SubscriptionTierIdToName = {
  [TierId.Light]: TierName.Light,
  [TierId.Start]: TierName.Start,
  [TierId.Plus]: TierName.Plus,
  [TierId.Premium]: TierName.Premium,
  [TierId.Max]: TierName.Max,
} as const;

export const SubscriptionTierNameToId = {
  [TierName.Light]: TierId.Light,
  [TierName.Start]: TierId.Start,
  [TierName.Plus]: TierId.Plus,
  [TierName.Premium]: TierId.Premium,
  [TierName.Max]: TierId.Max,
} as const;

export const convertTierIdToName = (id: ValueOf<typeof TierId>): ValueOf<typeof TierName> => {
  return SubscriptionTierIdToName[id];
};

export const convertTierNameToId = (name: ValueOf<typeof TierName>): ValueOf<typeof TierId> => {
  return SubscriptionTierNameToId[name];
};
